<!--
 * @Author: wupeiwen <javapeiwen2010@gmail.com>
 * @Date: 2022-06-06 17:50:27
 * @LastEditors: wupeiwen <javapeiwen2010@gmail.com>
 * @LastEditTime: 2022-06-15 00:25:06
 * @FilePath: /jy-dashboard-web/src/components/companyProfile/component-qyrz.vue
 * @Description: 企业认证
-->
<template>
  <div class="qyrz">
    <div class="content" v-loading="loading.qyrz">
      <div class="box" v-if="isExpansion"></div>
      <span
        class="button"
        :class="[isExpansion ? 'icon-bottom' : 'icon-top']"
        @click="isExpansion = !isExpansion"
        >{{ text }}</span
      >
      <div class="scroll-list" style="height: 90px" v-if="!loading.qyrz">
        <vue-seamless-scroll :class-option="classOption" :data="qyrz">
          <div class="list-item" v-for="(item, index) in qyrz" :key="index">
            <el-row :gutter="20">
              <el-col :span="12" class="text-overflow">{{ item.name }}</el-col>
              <el-col :span="12" class="text-overflow">{{ item.value }}</el-col>
            </el-row>
          </div>
        </vue-seamless-scroll>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
  data () {
    return {
      isExpansion: false
    }
  },
  computed: {
    ...mapState('company-profile', ['loading', 'qyrz']),
    text () {
      return this.isExpansion ? '收起' : '展开'
    },
    classOption () {
      return {
        // 配置超出容器才开始滚动
        limitMoveNum: true,
        // 速度
        step: 3,
        // 鼠标停止
        hoverStop: true,
        // 0 下 1 上 2 左 3 右
        direction: 1,
        singleHeight: 30,
        waitTime: 5000
      }
    }
  },
  methods: {
    ...mapActions('company-profile', ['getQYRZ'])
  },
  created () {
    this.getQYRZ()
  }
}
</script>

<style lang="scss">
.qyrz {
  padding-top: 52px;
  .content {
    height: 100%;
    position: relative;
    margin: 0 auto;
    width: calc(100% - 50px);
    .button {
      position: absolute;
      right: 12px;
      top: -40px;
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #ffffff;
      cursor: pointer;
    }
    .icon-bottom {
      &::before {
        margin-right: 10px;
        // content: url("/public/image/company-profile/icon/箭头向下@2x.png");
        content: "";
      }
    }
    .icon-top {
      &::before {
        margin-right: 10px;
        content: url("/public/image/company-profile/icon/箭头向上@2x.png");
      }
    }
    .box {
      z-index: 10000;
      position: absolute;
      right: -24px;
      top: -270px;
      width: 477px;
      height: 203px;
      background: url("/public/image/company-profile/bg/企业荣誉弹窗内容@2x.png")
          no-repeat center center,
        url("/public/image/company-profile/bg/企业荣誉弹窗@2x.png");
    }
    .scroll-list {
      overflow: hidden;
      .list-item {
        height: 30px;
        line-height: 30px;
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #ffffff;
      }
    }
  }
}
</style>
